import { DS_F2W_HR_Team, DS_F2W_Edit, DS_F2W_Business_Travel_Team } from 'Constants/F2wRolesConstants';
import { GET_USER_SUCCESS } from 'Constants/UserConstants';

const defaultState = {
  given_name: '',
  family_name: '',
  upn: '',
  roles: [''],
  email: '',
};

export default function currentUserReducer(state = defaultState, action) {
  const isProd = window.location.hostname.includes('fly2work.tui-dx.com');

  if (!isProd) {
    if (action.type === GET_USER_SUCCESS) {
      return {
        ...action.data.user,
        roles: [DS_F2W_Edit, DS_F2W_Business_Travel_Team, DS_F2W_HR_Team],
      };
    }
    return state;
  } else {
    if (action.type === GET_USER_SUCCESS) {
      return {
        ...action.data.user,
      };
    }
    return state;
  }
}
